import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { CardModule } from '@epicuro-next/ataraxia/card';
import { DateModule } from '@epicuro-next/ataraxia/date';
import { DropdownModule } from '@epicuro-next/ataraxia/dropdown';
import { EmptyPlaceholderModule } from '@epicuro-next/ataraxia/empty-placeholder';
import { FormatPricePipe } from '@epicuro-next/ataraxia/formatting';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { InputDateRangeModule } from '@epicuro-next/ataraxia/input-date-range';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { PopoverModule } from '@epicuro-next/ataraxia/popover';
import { SkeletonBasicModule } from '@epicuro-next/ataraxia/skeleton-basic';
import { SnackBarModule } from '@epicuro-next/ataraxia/snack-bar';
import { TooltipDirective } from '@epicuro-next/ataraxia/tooltip';
import { DataEngagementApiModule } from '@epicuro-next/data/engagement/engagement-api';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { EngagementCommonModule } from '@epicuro-next/features/engagement/engagement-common';
import { HotListIndicatorModule } from '@epicuro-next/features/engagement/hot-list-indicator';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LetDirective } from '@ngrx/component';

import {
  DashboardEmptyStateComponent,
  DashboardHeaderControlsComponent,
  DashboardTableComponent,
} from './components';
import { BestPerformingArticlesFiltersComponent } from './components/best-performing-articles-filters/best-performing-articles-filters.component';
import { DashboardColumnSortComponent } from './components/dashboard-column-sort/dashboard-column-sort.component';
import { DashboardFilterSelectComponent } from './components/dashboard-filter-select/dashboard-filter-select.component';
import {
  BestPerformingListsComponent,
  DashboardPageComponent,
} from './containers';
import { BestPerformingArticlesComponent } from './containers/best-performing-articles/best-performing-articles.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  declarations: [
    BestPerformingArticlesComponent,
    BestPerformingArticlesFiltersComponent,
    BestPerformingListsComponent,
    DashboardEmptyStateComponent,
    DashboardFilterSelectComponent,
    DashboardHeaderControlsComponent,
    DashboardPageComponent,
    DashboardTableComponent,
  ],
  imports: [
    CommonModule,
    AvatarModule,
    MediaPreviewModule,
    IconsModule,
    DropdownModule,
    SkeletonBasicModule,
    EmptyPlaceholderModule,
    PopoverModule,
    DateModule,
    InputDateRangeModule,
    TooltipDirective,
    ClipboardModule,
    SnackBarModule,
    IconsModule,
    EngagementCommonModule,
    DashboardRoutingModule,
    DataEngagementApiModule,
    NgbModule,
    LetDirective,
    CardModule,
    DashboardColumnSortComponent,
    FormatPricePipe,
    HotListIndicatorModule,
  ],
})
export class DashboardModule {}
DontTreeShake(BestPerformingArticlesFiltersComponent);
